import {
    FETCH_HELP_TOPICS_REQUEST,
    FETCH_HELP_TOPICS_SUCCESS,
    FETCH_HELP_TOPICS_FAILURE,
    CREATE_HELP_TOPIC_REQUEST,
    CREATE_HELP_TOPIC_SUCCESS,
    CREATE_HELP_TOPIC_FAILURE,
    UPDATE_HELP_TOPIC_REQUEST,
    UPDATE_HELP_TOPIC_SUCCESS,
    UPDATE_HELP_TOPIC_FAILURE,
    DELETE_HELP_TOPIC_REQUEST,
    DELETE_HELP_TOPIC_SUCCESS,
    DELETE_HELP_TOPIC_FAILURE,
  } from "./types";
  
  import {
    fetchHelpTopics,
    createHelpTopic,
    updateHelpTopic,
    deleteHelpTopic,
  } from "../../services/helpTopicService";
  
  // Action Creators
  export const fetchHelpTopicsRequest = () => ({ type: FETCH_HELP_TOPICS_REQUEST });
  export const fetchHelpTopicsSuccess = (topics) => ({
    type: FETCH_HELP_TOPICS_SUCCESS,
    payload: topics,
  });
  export const fetchHelpTopicsFailure = (error) => ({
    type: FETCH_HELP_TOPICS_FAILURE,
    payload: error,
  });
  
  export const createHelpTopicRequest = () => ({ type: CREATE_HELP_TOPIC_REQUEST });
  export const createHelpTopicSuccess = (topic) => ({
    type: CREATE_HELP_TOPIC_SUCCESS,
    payload: topic,
  });
  export const createHelpTopicFailure = (error) => ({
    type: CREATE_HELP_TOPIC_FAILURE,
    payload: error,
  });
  
  export const updateHelpTopicRequest = () => ({ type: UPDATE_HELP_TOPIC_REQUEST });
  export const updateHelpTopicSuccess = (topic) => ({
    type: UPDATE_HELP_TOPIC_SUCCESS,
    payload: topic,
  });
  export const updateHelpTopicFailure = (error) => ({
    type: UPDATE_HELP_TOPIC_FAILURE,
    payload: error,
  });
  
  export const deleteHelpTopicRequest = () => ({ type: DELETE_HELP_TOPIC_REQUEST });
  export const deleteHelpTopicSuccess = (topicId) => ({
    type: DELETE_HELP_TOPIC_SUCCESS,
    payload: topicId,
  });
  export const deleteHelpTopicFailure = (error) => ({
    type: DELETE_HELP_TOPIC_FAILURE,
    payload: error,
  });
  
  // Thunks
  export const fetchHelpTopicsAction = () => async (dispatch) => {
    dispatch(fetchHelpTopicsRequest());
    try {
      const response = await fetchHelpTopics();
      if (response.success) {
        dispatch(fetchHelpTopicsSuccess(response.data));
      } else {
        dispatch(fetchHelpTopicsFailure(response.error));
      }
    } catch (error) {
      dispatch(fetchHelpTopicsFailure(error.message || "Failed to fetch help topics"));
    }
  };
  
  export const createHelpTopicAction = (payload) => async (dispatch) => {
    dispatch(createHelpTopicRequest());
    try {
      const response = await createHelpTopic(payload);
      if (response.success) {
        dispatch(createHelpTopicSuccess(response.data));
      } else {
        dispatch(createHelpTopicFailure(response.error));
      }
    } catch (error) {
      dispatch(createHelpTopicFailure(error.message || "Failed to create help topic"));
    }
  };
  
  export const updateHelpTopicAction = (topicId, payload) => async (dispatch) => {
    dispatch(updateHelpTopicRequest());
    try {
      const response = await updateHelpTopic(topicId, payload);
      if (response.success) {
        dispatch(updateHelpTopicSuccess(response.data));
      } else {
        dispatch(updateHelpTopicFailure(response.error));
      }
    } catch (error) {
      dispatch(updateHelpTopicFailure(error.message || "Failed to update help topic"));
    }
  };
  
  export const deleteHelpTopicAction = (topicId) => async (dispatch) => {
    dispatch(deleteHelpTopicRequest());
    try {
      const response = await deleteHelpTopic(topicId);
      if (response.success) {
        dispatch(deleteHelpTopicSuccess(topicId));
      } else {
        dispatch(deleteHelpTopicFailure(response.error));
      }
    } catch (error) {
      dispatch(deleteHelpTopicFailure(error.message || "Failed to delete help topic"));
    }
  };
  